import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import React from 'react';
import { css, createGlobalStyle } from 'styled-components';
import '../../utils/assertions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { color, fontWeight } from '../../utils/theme.es.js';
import { useEnhancedEffect } from '../../utils/useEnhancedEffect.es.js';
import 'react-is';
var GlobalStyleCSS = css(["*,*:before,*:after{box-sizing:inherit;}:root{--navbar-height:64px;}:focus:not(:focus-visible){outline:0;}html{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-moz-text-size-adjust:100%;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%;font-size:", ";box-sizing:border-box;}body{color:", ";background-color:", ";font-family:", ";line-height:", ";font-size:", ";font-weight:", ";}html,body{margin:0;padding:0;height:100%;}h1,h2,h3,h4,h5,h6{margin:0;}figure{margin:0;padding:0;}ul,ol,li{margin:0;padding:0;list-style:none;}input,textarea,select,button{font:inherit;letter-spacing:inherit;}a{color:", ";}button{color:inherit;border-radius:0;border:none;background-color:transparent;}button *{pointer-events:none;}table{width:100%;}[data-color-mode='light']{color:", ";background-color:", ";a{color:", ";}}[data-color-mode='dark']{color:", ";background-color:", ";a{color:", ";}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.baseFontSize;
}, color("text.base"), color("background.base"), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily.base;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.lineHeights.base;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.baseFontSize;
}, fontWeight("regular"), color("text.base"), color("neutral.900"), color("neutral.0"), color("neutral.900"), color("neutral.50"), color("neutral.1000"), color("neutral.50"));
var InternalGlobalStyle = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    ", ";\n"])), GlobalStyleCSS);

var insertCssImports = function insertCssImports(enabled) {
  if (document.getElementById("global-css-imports") || !enabled) {
    return;
  }

  var head = document.head || document.getElementsByTagName("head")[0];
  var styleElement = document.createElement("style");
  styleElement.id = "global-css-imports";
  head.insertBefore(styleElement, head.firstChild);
  styleElement.appendChild(document.createTextNode("\n            @import 'https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.min.css';\n            @import 'https://cdn.landr.com/fonts/Sailec/style.css';\n"));
};

var GlobalStyle = function GlobalStyle(_ref5) {
  var _ref5$withCssImports = _ref5.withCssImports,
      withCssImports = _ref5$withCssImports === void 0 ? true : _ref5$withCssImports;
  useEnhancedEffect(function () {
    return insertCssImports(withCssImports);
  }, []);
  return (
    /* @__PURE__ */
    React.createElement(InternalGlobalStyle, null)
  );
};

export { GlobalStyle };